import { ConvertibleFilingTalkRanges } from '../../../../../../../../common/hooks/useConvertibleFilingTalkRanges';
import { OfferingType } from '../../../../../../../../graphql';
import { SyndicateIndicationQuery } from '../../../../context/hooks/syndicate/__generated__';
import { getInterestLevelOrderType } from '../../common/indication-section-form/IndicationSectionForm.model';
import {
  emptyInterestLevelValue,
  IndicationFormValues,
} from '../../common/utils/IndicationSectionValidation';

type CreateInitialValuesParams = {
  offeringType: OfferingType | null;
  indication: SyndicateIndicationQuery['basicPublishedOffering']['orderBook']['institutionalIndication'];
  convertibleFilingTalkRanges: ConvertibleFilingTalkRanges;
  isIndicationPriceAsPercentageParEnabled: boolean;
};

export const createInitialValues = ({
  indication,
  convertibleFilingTalkRanges,
  offeringType,
  isIndicationPriceAsPercentageParEnabled,
}: CreateInitialValuesParams): IndicationFormValues => {
  const interestLevels =
    indication?.interestLevels.map(
      ({
        interestQuantity,
        interestUnit,
        limitType,
        limitPrice,
        coupon,
        premium,
        percentageOfPar,
      }) => ({
        interestQuantity,
        interestUnit,
        orderType: getInterestLevelOrderType({
          interestLevel: {
            coupon,
            premium,
            limitPrice,
          },
          offeringType: offeringType,
          convertibleFilingTalkRanges,
          isIndicationPriceAsPercentageParEnabled,
        }),
        limitPrice: limitPrice ?? null,
        limitType: limitType ?? null,
        coupon: coupon ?? null,
        premium: premium ?? null,
        percentageOfPar: percentageOfPar ?? null,
      })
    ) ?? [];

  return {
    trancheId: indication?.trancheId ?? null,
    instrumentId: indication?.instrumentId ?? null,
    currencyCode: indication?.currencyCode ?? null,
    selectedInterestUnit: interestLevels[0]?.interestUnit ?? null,
    interestLevels: interestLevels.length > 0 ? interestLevels : [emptyInterestLevelValue],
  };
};
